import { render, staticRenderFns } from "./Inovations.vue?vue&type=template&id=39daa956&scoped=true"
import script from "./Inovations.vue?vue&type=script&lang=js"
export * from "./Inovations.vue?vue&type=script&lang=js"
import style0 from "./Inovations.vue?vue&type=style&index=0&id=39daa956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39daa956",
  null
  
)

export default component.exports